export default function Security() {
    return (
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <h1 className="mb-4">Security</h1>
            <p>
              Your data’s safety is our top priority. AKSEMA is built with enterprise-grade security from the ground up.
            </p>
            <ul>
              <li>End-to-end encryption in transit and at rest</li>
              <li>Regular third-party security audits</li>
              <li>Zero data retention policy for API usage</li>
              <li>Compliance with GDPR, CCPA, and SOC 2 Type 2 standards</li>
            </ul>
            <p className="mt-3">
              For security concerns or vulnerability reports, email: aksemainventory@gmail.com
            </p>
          </div>
        </div>
      </div>
    );
  }